import { ROLES } from "../../helpers/commons.helpers";

/**
 * User profile route definitions.
 *
 * These routes are lazy-loaded and intended to be used as children of the
 * authenticated layout. Each route includes a `meta` object with properties
 * consulted by navigation guards and permission checks.
 *
 * @typedef {Object} ProfileRouteMeta
 * @property {boolean} requiresAuth - When true the route requires authentication.
 * @property {Array<string>} roles - Array of role identifiers allowed to access the route.
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
    {
        path: "/my-profile",
        name: "MyProfile",
        meta: {
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
                /* webpackChunkName: "profile" */ "@/user/pages/Profile"
            )
    }
]